import { useEffect, useRef, useState } from "react"
import { BACKEND } from "../config/configEnvs"
import { FaWordpress, FaExternalLinkAlt, FaLink, FaPlus, FaEdit, FaLaptopCode, FaTrash } from "react-icons/fa"
import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import MainSaveButton from "../components/ui/components/MainSaveButton";
import axios from "axios";
import WebsBoxItemContainer from "../components/proyectos/WebsBoxItemContainer";
import { useSelector } from "react-redux";
import PaginationItem from "../components/ui/components/Pagination";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import Modal from "../components/ui/Modal";
import TooltipInfoQuestion from "../components/ui/components/TooltipInfoQuestion";
import DescriptionModal from "../components/proyectos/DescriptionModal";
import CheckBox from "../components/ui/components/CheckBox";
import { toast } from "react-toastify";
import WebRowItemContainer from "../components/proyectos/WebRowItemContainer";
import ChipInfo from "../components/proyectos/ChipInfo";
import { webServiceStatus } from "../utils/rawData/serviceStatus";
import Selector from "../components/ui/components/Selector";
import FilterButton from "../components/ui/components/FilterButton";
import OpcionesRecompraPotencial from "../utils/plainValues/OpcionesRecompraPotencial";
import { Limits10_50 } from "../utils/plainValues/DefaultLimits";
import SearchBar from "../components/ui/components/SearchBar";
import DateInput from "../components/ui/components/DateInput";
import { EnfoqueWebOptions } from "../utils/rawData/enfoqueWebOptions";
import Multiselector from "../components/ui/components/Multiselector";
import { vipClientValues } from "../utils/rawData/vipClientValues";
import CommentModal from "../components/ui/proyectos/CommentModal";
import StartSpeechRecognition from "../utils/services/recordingAudioServices/StartSpeechRecognition";
import StopSpeechRecognition from "../utils/services/recordingAudioServices/StopSpeechRecognition";
import ClearRecordedAudio from "../utils/services/recordingAudioServices/ClearRecordedAudio";
import CancelRecording from "../utils/services/recordingAudioServices/CancelRecording";
import ClientDataModal from "../components/ui/proyectos/ClientDataModal";
import OpenMeets from "../components/seguimiento/handlersButtonsPanel/OpenMeets";
import OpenClientReviewsRequests from "../components/seguimiento/handlersButtonsPanel/OpenClientReviewsRequests";


const ProyectosWebs = () => {

  const user = useSelector((state) => state.auth.user)
  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION"
  const isOperative = user.area.toUpperCase() !== "COMERCIAL" && user.area.toUpperCase() !== "ADMINISTRACION"
  const isCommercial = user.area.toUpperCase() === "COMERCIAL"

  // console.log("Admin: ", isAdmin)
  // console.log("Vertical: ", isOperative)
  // console.log("Horizontal: ", isCommercial)

  const [clients, setClients] = useState([])
  const [workers, setWorkers] = useState([])
  const [areaWorkers, setAreaWorkers] = useState([])

  const [webServices, setWebServices] = useState([])
  const [loadingStatus, setLoadingStatus] = useState(false)

  // Por defecto aparecen los servicios mas contratados de la agencia seleccionados
  // Aula virtual, Super Tiendas Virtuales, Landing Page ADS y Web de informativas
  const [serviceFilters, setServiceFilters] = useState(["66168fb2e5d3e65b502e8c98", "6577752ac1c6ac85e69c86ed", "6577638bc1c6ac85e69c79cf", "657038a8132e0436ce6f5fdc", "657037fe132e0436ce6f5fd6"])

  // Por defecto aparecen los proyectos que nos interesan
  const [statusFilters, setStatusFilters] = useState(["Por comenzar", "En proceso", "Falta pagar", "Cotizando nuevas funciones", "Falta migrar"])

  const [view, setView] = useState("Horizontal")

  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(50)

  const [totalDocs, setTotalDocs] = useState(1)
  const [totalPages, setTotalPages] = useState(1)

  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")

  const [agencyWeb, setAgencyWeb] = useState(false)

  const [brandName, setBrandName] = useState("") // Búsqueda de texto de la marca

  const [responsible, setResponsible] = useState("")
  const [enfoqueWeb, setEnfoqueWeb] = useState("")

  // Modal de demo - Gestiona los items del registro padre para Webs
  const DEMO_WEB_PARENT_ID = "67ba060a7510267b9cef8ced" // ID del registro padre de demos webs en accesosAreaComercial
  const [openModalDemo, setOpenModalDemo] = useState(false)
  const [demos, setDemos] = useState([])
  const [demoTab, setDemoTab] = useState("list")
  const [demoForm, setDemoForm] = useState({
    itemName: "",
    itemLink: "",
    subCategoryLinks: [],
  })
  const [editingDemoIndex, setEditingDemoIndex] = useState(null)

  const getDemos = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/accesosAreaComercial/${DEMO_WEB_PARENT_ID}`)
      setDemos(response.data.items || [])
    } catch (e) {
      toast.error("Error al obtener los demos")
    }
  }

  const saveDemosItems = async (updatedItems) => {
    try {
      await axios.put(`${BACKEND}/api/accesosAreaComercial/${DEMO_WEB_PARENT_ID}`, {
        items: updatedItems,
      })
      setDemos(updatedItems)
    } catch (e) {
      toast.error("Error al guardar los demos")
      throw e
    }
  }

  const createDemo = async () => {
    try {
      const newItem = { ...demoForm }
      const updatedItems = [...demos, newItem]
      await saveDemosItems(updatedItems)
      toast.success("Demo creado con éxito")
      resetDemoForm()
      setDemoTab("list")
    } catch (e) {
      // error ya manejado en saveDemosItems
    }
  }

  const updateDemo = async () => {
    try {
      const updatedItems = demos.map((item, i) =>
        i === editingDemoIndex ? { ...demoForm } : item
      )
      await saveDemosItems(updatedItems)
      toast.success("Demo actualizado con éxito")
      resetDemoForm()
      setDemoTab("list")
    } catch (e) {
      // error ya manejado en saveDemosItems
    }
  }

  const resetDemoForm = () => {
    setDemoForm({ itemName: "", itemLink: "", subCategoryLinks: [] })
    setEditingDemoIndex(null)
  }

  const startEditDemo = (demo, index) => {
    setEditingDemoIndex(index)
    setDemoForm({
      itemName: demo.itemName || "",
      itemLink: demo.itemLink || "",
      subCategoryLinks: demo.subCategoryLinks || [],
    })
    setDemoTab("create")
  }

  const addSubCategoryLink = () => {
    setDemoForm(prev => ({
      ...prev,
      subCategoryLinks: [...prev.subCategoryLinks, { itemName: "", itemLink: "" }]
    }))
  }

  const removeSubCategoryLink = (index) => {
    setDemoForm(prev => ({
      ...prev,
      subCategoryLinks: prev.subCategoryLinks.filter((_, i) => i !== index)
    }))
  }

  const updateSubCategoryLink = (index, field, value) => {
    setDemoForm(prev => ({
      ...prev,
      subCategoryLinks: prev.subCategoryLinks.map((link, i) =>
        i === index ? { ...link, [field]: value } : link
      )
    }))
  }

  // Modal de comentarios y descripcion
  const [openModalComments, setOpenModalComments] = useState(false) // Modal comentarios
  const [openModalDescription, setOpenModalDescription] = useState(false) // Modal descripción
  const [selectedService, setSelectedService] = useState({}) // Info servicio seleccionado
  const [newComment, setNewComment] = useState("")
  const [commentType, setCommentType] = useState("default")
  const [recompraPotencial, setRecompraPotencial] = useState("")



  /// Sección de audios ///
  // Audio recording state (comentarios modal)
  const mediaRecorderRef = useRef(null)
  const audioChunksRef = useRef([])
  const recordingTimerRef = useRef(null)
  const isRecordingRef = useRef(false)
  const [isRecording, setIsRecording] = useState(false)
  const [recordingTime, setRecordingTime] = useState(0)
  const [recordedAudioFile, setRecordedAudioFile] = useState(null)
  const [recordedAudioUrl, setRecordedAudioUrl] = useState("")
  const [uploadingAudio, setUploadingAudio] = useState(false)

  
  // Web Speech API (dictado en vivo)
  const recognitionRef = useRef(null)
  const [isDictating, setIsDictating] = useState(false)
  const [interimTranscript, setInterimTranscript] = useState("")
  const dictationBaseRef = useRef("") // Texto existente al iniciar el dictado
  const dictatedFinalRef = useRef("") // Frases finales acumuladas
  /// Fin sección de audios ///


  
  const [priorityFilters, setPriorityFilters] = useState([])
  const [vipClient, setVipClient] = useState("")

  const getClients = async () => { // Obtener los clientes
    try {
      setLoadingStatus(true)

      const body = {}

      let url = `${BACKEND}/api/userProcessesInterface/getClientsByServiceCategory?category=Web&page=${page}&limit=${limit}`

      if (brandName) {
        url += `&brandName=${encodeURIComponent(brandName)}`
      }

      if (enfoqueWeb) {
        url += `&enfoqueWeb=${encodeURIComponent(enfoqueWeb)}`
      }

      if (statusFilters) {
        body.statusFilters = statusFilters
      }

      if (serviceFilters) {
        body.serviceFilters = serviceFilters
      }

      if (agencyWeb) {
        url += `&activoAgencia=${encodeURIComponent(agencyWeb)}`
      }

      if (startDate) {
        url += `&startDate=${encodeURIComponent(new Date(startDate).toISOString())}`
      }

      if (endDate) {
        url += `&endDate=${encodeURIComponent(new Date(endDate).toISOString())}`
      }

      if (responsible) {
        url += `&responsible=${encodeURIComponent(responsible)}`
      }

      if (recompraPotencial) {
        url += `&recompraPotencial=${encodeURIComponent(recompraPotencial)}`
      }

      if (priorityFilters && priorityFilters.length > 0) {
        body.priorityFilters = priorityFilters
      }

      if (vipClient) {
        url += `&vipClient=${encodeURIComponent(vipClient)}`
      }

      console.log(url)

      const response = await axios.post(url, body)

      setClients(response.data.clients)
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)

      setLoadingStatus(false)

    } catch (error) {
      toast.error("Error al obtener los servicios")
      return null
    }
  }

  const getWorkers = async () => { // Obtener los trabajadores
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0&where[activo][equals]=true`)
      const filteredWorkers = response.data.docs.filter(worker => worker.area.toUpperCase() === "COMERCIAL" || worker.area.toUpperCase() === "ADMINISTRACION")
      const filteredAreaWorkers = response.data.docs.filter(worker => worker.puesto.toUpperCase() === "ASISTENTE DE WORDPRESS Y CMS" || worker.puesto.toUpperCase() === "DESARROLLADOR DE WORDPRESS Y CMS")
      setWorkers(filteredWorkers)
      setAreaWorkers(filteredAreaWorkers)
    } catch (error) {
      return false
    }
  }

  const getWebServices = async () => { // Obtener los servicios de webs
    try {
      const response = await axios.get(`${BACKEND}/api/servicios?where[categoria][equals]=Web&limit=0`)
      setWebServices(response.data.docs)
    } catch (error) {
      console.log(error)
    }
  }

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  useEffect(() => { // Solo se ejecuta cuando se vacea la barra de búsqueda
    if (brandName === "") {
      getClients(); // Solo se ejecuta cuando se reinicia la búsqueda
      setPage(1); // Reiniciar la paginación si es necesario
    }
  }, [brandName]);

  useEffect(() => { // Obtenemos los clientes
    getWebServices()
    getClients()
    getWorkers()
    getDemos()
  }, [])

  useEffect(() => { // Obtenemos los clientes cada que cambia la página y el límite
    getClients()
  }, [page, limit])

  useEffect(() => {
    getClients()
  }, [agencyWeb, startDate, endDate, responsible, enfoqueWeb, recompraPotencial, vipClient])

  const didMountFiltersRef = useRef(false)

  useEffect(() => {
    if (!didMountFiltersRef.current) {
      didMountFiltersRef.current = true
      return
    }
    const timeout = setTimeout(() => {
      getClients();
    }, 3000);
  
    return () => clearTimeout(timeout); // Limpia el timeout si el efecto se vuelve a ejecutar
  }, [serviceFilters, statusFilters, priorityFilters]);

  // Permisos
  const [permissions, setPermissions] = useState({
    isAdmin: false,
    isAssistant: false,
    isBossArea: false,
    isUserArea: false,
  });

  const definePermissions = (user) => {
    const updatedPermissions = {
      isAdmin: user.area.toUpperCase() === "ADMINISTRACION",
      isAssistant: user.area.toUpperCase() === "ADMINISTRACION" && user.puesto.toUpperCase() === "ASISTENTE",
      isBossArea: user.area.toUpperCase() === "SOFTWARE" && user.puesto.toUpperCase() === "DESARROLLADOR DE WORDPRESS Y CMS" || user.puesto.toUpperCase() === "ASISTENTE DE WORDPRESS Y CMS",
      isUserArea: user.area.toUpperCase() === "SOFTWARE" && (user.puesto.toUpperCase() === "DESARROLLADOR DE WORDPRESS Y CMS" || user.puesto.toUpperCase() === "ASISTENTE DE WORDPRESS Y CMS"),
    };
    setPermissions(updatedPermissions);
  };
  
  useEffect(() => {
    if (user) definePermissions(user);
  }, [user]);

  //Descripcion
  const parseDescription = (description) => { // Parsear la info
    if (!description || typeof description !== "string") {
      return [];
    }
    return description.split("\n").map((item) => {
      const [key, value] = item.split(":");
      return {
        key: key ? key.trim() : "",
        value: value ? (value.trim() === "✓" ? "Si" : value.trim()) : "-",
      };
    });
  };  

  const descriptionText = selectedService?.customDescriptionActive
  ? selectedService?.customDescriptionText
  : selectedService?.servicio?.preciosUnitarios.find(
      (precioUnit) => precioUnit?.plan.id === selectedService?.planServicio?.id
    )?.descripcion;

  const parsedDescription = parseDescription(descriptionText);

// Gestión de columnas activas y permisos

  const conditions = {
    isAdmin: isAdmin,
    isOperative: isOperative, 
    isCommercial: isCommercial
  }

  // Estado para controlar la visibilida ddel modal
  const [showColFiltersModal, setShowColFiltersModal] = useState(false);

  // Modal reuniones (OpenMeets) para la columna 9.5
  const [openMeetsModal, setOpenMeetsModal] = useState(false);
  const [meetsServiceId, setMeetsServiceId] = useState(null);

  // Modal solicitud revisiones (OpenClientReviewsRequests) para la columna 8.5
  const [openSolicitudRevisionesModal, setOpenSolicitudRevisionesModal] =
    useState(false);
  const [solicitudRevisionesServiceId, setSolicitudRevisionesServiceId] =
    useState(null);

  // Definir combos para el rapido seleciconado de opciones
  const combos = [
    { id: 1, name: "Administrativo", cols: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 41, 46, 48] },
    { id: 2, name: "Proyecto", cols: [1, 2, 3, 4, 5, 6, 7, 8, 11, 13, 14, 15, 17, 18, 21, 22, 23, 24, 25, 26, 28, 29, 30, 32, 34, 35, 36, 37, 38, 39, 41, 42, 43, 44, 45, 46, 47, 48] },
    { id: 3, name: "Comercial", cols: [1, 2, 4, 7, 8, 10, 11, 12, 13, 14, 15, 16, 17, 19, 20, 21, 22, 23, 30, 31, 32, 33, 34, 37, 41, 42, 43, 44] },
    { id: 4, name: "Todas", cols: [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 41, 42, 43, 44, 45, 46, 47, 48] }
  ];

  //Columnas activas, con restricciones por áreas

  const cols = [
    { first: true, sticky: true, name: "Coti", show: true, conditions: {"isAdmin": true, "isOperative": false, "isCommercial": true} },
    { second: true, name: "%", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { third: true, name: "Cliente", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "CheckList", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Sistema", },
    { name: "Ir al proyecto", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false} },
    { name: "Tipo de web", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Datos cliente", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "VIP", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Link Drive", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Solicitud revisiones", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Información enviada", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Especialista" },
    { name: "Google Meet", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Regalo(?)", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Enfoque web", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Recompra potencial", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Moroso", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "ID Cotización", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Estado", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Asistente" },
    { name: "Formulario", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Descripción servicio", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Comentarios vendedor", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Comentarios operativa", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Plan", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Encargado", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Nro encargado", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Tipo cliente", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Especialista" },
    { name: "Responsable", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Sistema" },
    { name: "Ingreso", show: true, conditions: {"isAdmin": true, "isOperative": false, "isCommercial": true}, chipContent: "Sistema", description: "Fecha ingreso sistema (registro venta). Fecha cuando el cliente hace el primer pago." },
    { name: "Inicio", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Sistema", description: "Fecha cuando debió/debe iniciar el proyecto (sistema)." },
    { name: "Inicio Manual", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, description: "Fecha de inicio proyecto (manual). Fecha en cuando el jefe de área designa una fecha para inciar el proyecto." },
    { name: "Fin", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, description: "Fecha en la que debió/debe finalizar el proyecto." },
    { name: "Entrega", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Admin", description: "Fecha en la que finalizó el proyecto. (Pago al 100% y entrega de credenciales/accesos/migración/capacitación)." },
    { name: "Grabación capacitación", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Migración oficial", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Fecha max envío info", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false}, chipContent: "Especialista", description: "Fecha máxima del envio de la informacion que el cliente debe enviar al especialista, si esta fuera de la fecha el servicio se congela" },
    { name: "Fecha envío info al 100%", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false}, description: "Esta en la fecha cuando realmente se envio la informacion segun el especialista o operativa" },
    { name: "Responsable retraso", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Asistente", description: "Se establece quien tuvo el primer retraso " },
    { name: "Fecha max pago", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Especialista", description: "Fecha máxima de pago del cliente, si no se paga antes de esta fecha el servicio se congela" },
    { name: "Vendedor", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Fecha inicio cobranza", show: true, conditions: {"isAdmin": true, "isOperative": false, "isCommercial": true}, chipContent: "Admin", description: "Fecha cuando administracion o ventas inicia la cobranza del cliente" },
    { name: "Duración del proyecto establecido", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, descripcion: "Tiempo en dias respecto a la duracion total del proyecto establecida por administración" },
    { name: "Duración (hasta la fecha de hoy si esta en proceso)", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false}, description: "Tiempo en dias que lleva el proyecto desde la fecha de la primera reunion hasta la fecha de hoy" },
    { name: "Fecha culminación operativa", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false}, description: "Fecha cuando se termino la web y el cliente no tiene mas cambios"},
    { name: "Duración proyecto de operativa", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, description: "Tiempo en dias desde que el cliente envio la informacion al 100% hasta que el area operativa termino con la pagina web (sin incluir capacitacion, entrega de credenciales)" },
    { name: "Duración real del proyecto", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, description: "Tiempo en dias del proyecto desde que se vendio o se hizo el primer pago hasta que se entrego el proyecto al 100%" },
    { name: "Precio venta", show: true, conditions: {"isAdmin": true, "isOperative": false, "isCommercial": true} },
    { name: "Link desarrollo", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Link oficial", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Web referencia", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Copia seguridad referencia", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false} },
    { name: "Capacitación hecha", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Link capacitación", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false} },
    { name: "Link diseño gráfico", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
  ]

  const colsWithIds = cols.map((col, index) => ({ ...col, id: index + 1 }));

  // Función helper para evaluar si una columna debe mostrarse
  const shouldShowColumn = (col) => {
    // Check if column is enabled in colFilters
    if (!colFilters[col.id]) return false;
    // Check conditions
    if (!col.conditions) return true;
    return Object.keys(col.conditions).some(role => conditions[role] && col.conditions[role]);
  };

  const userHasAccess = (col) => {
    if (isAdmin && col.conditions.isAdmin) return true;
    if (isOperative && col.conditions.isOperative) return true;
    if (isCommercial && col.conditions.isCommercial) return true;
    return false;
  };

  // Estado para las columnas activas con carga desde localStorage
  const [colFilters, setColFilters] = useState(() => {
    // Intentar cargar desde localStorage
    const savedFilters = localStorage.getItem("activeTableColsProyectosWebs");
    if (savedFilters) {
      try {
        return JSON.parse(savedFilters);
      } catch (error) {
        console.error("Error al parsear columnas guardadas:", error);
      }
    }
    // Si no hay datos guardados, activar todas las columnas por defecto
    const initialFilters = {};
    colsWithIds.forEach(col => {
      initialFilters[col.id] = true;
    });
    return initialFilters;
  });

  // Guardar en localStorage cada vez que cambien las columnas activas
  useEffect(() => {
    localStorage.setItem("activeTableColsProyectosWebs", JSON.stringify(colFilters));
  }, [colFilters]);

  // Calcular offsets dinámicos para columnas sticky según cuáles son visibles
  const stickyOffsets = (() => {
    const defs = [
      { key: 'first', width: 3.5 },
      { key: 'second', width: 5 },
      { key: 'third', width: 10 },
    ];
    const offsets = {};
    let cumulative = 0;
    for (const def of defs) {
      offsets[def.key] = `${cumulative}rem`;
      const stickyCol = colsWithIds.find(c => c[def.key]);
      if (stickyCol && shouldShowColumn(stickyCol)) {
        cumulative += def.width;
      }
    }
    return offsets;
  })();

  const handleAddComment = async () => { // Agregar comentario en modal de comentarios del proyecto
    const text = newComment.trim()
    let audioUploaded = null
    if (!text && !recordedAudioFile) {
      toast.error("Debes escribir un comentario o grabar un audio.")
      return
    }

    // if (recordedAudioFile) {
    //   audioUploaded = await uploadAudio()
    //   if (!audioUploaded?.url && !audioUploaded?.id) {
    //     toast.error('No se pudo subir el audio')
    //     return
    //   }
    // }

    const nuevoComentario = {
      usuario: user.id,
      comentario: text || "",
      fecha: new Date().toISOString(),
      type: commentType || "default",
      ...(audioUploaded ? { audioUrl: audioUploaded.url || "", audioId: audioUploaded.id || null } : {})
    }

    const comentariosOperativa = selectedService?.comentariosOperativa || [];

    const updatedComentariosOperativa = [
      ...comentariosOperativa.map((comentario) => ({
        ...comentario,
        usuario: typeof comentario.usuario === "object" ? comentario.usuario.id : comentario.usuario,
      })),
      nuevoComentario,
    ];

    const shouldFreeze = (commentType || "default") === "updateStatus"

    const updatedServiceData = {
      ...selectedService,
      comentariosOperativa: updatedComentariosOperativa,
      ...(shouldFreeze ? { estado: "Congelado" } : {}),
    };

    // Actualiza el servicio seleccionado localmente para reflejar el nuevo comentario
    setSelectedService(updatedServiceData);

    // Actualiza el estado de clients para que el cambio sea visible en la tabla
    setClients((prevClients) =>
      prevClients.map((client) => {
        if (client.id !== selectedService?.cotizacion?.cliente?.id) return client;
        console.log("Paso 1")
        return {
          ...client,
          services: client.services.map((srv) =>
            srv.id === selectedService.id
              ? { ...srv, comentariosOperativa: updatedComentariosOperativa, ...(shouldFreeze ? { estado: "Congelado" } : {}) }
              : srv
          ),
        };
      })
    );

    try {
      const body = { comentariosOperativa: updatedComentariosOperativa, ...(shouldFreeze ? { estado: "Congelado" } : {}) }
      await axios.put(
        `${BACKEND}/api/serviciosCotizaciones/${updatedServiceData.id}`,
        body
      );
      toast.success("Comentario agregado con éxito");
      setNewComment("")
      ClearRecordedAudio({
        setRecordedAudioFile,
        recordedAudioUrl,
        setRecordedAudioUrl,
        setRecordingTime,
      })
      setOpenModalComments(false)
      setCommentType("default")
    } catch (error) {
      console.log(error);
      toast.error("Error al agregar el comentario");
    }
  };

  // Datos del cliente 
  const [openModalClientData, setOpenModalClientData] = useState(false) // estado modal
  const [selectedClientData, setSelectedClientData] = useState(null) // cliente seleccionado

  return (
    <div className="flex flex-col h-screen w-full">

      <CommentModal
        openModal={openModalComments}
        setOpenModal={setOpenModalComments}
        selectedService={selectedService}
        setSelectedService={setSelectedService}
        newComment={newComment}
        setNewComment={setNewComment}
        type={commentType}
        cancelRecording={() => CancelRecording({
          isRecording,
          mediaRecorderRef,
          setIsRecording,
          setRecordedAudioFile,
          recordedAudioUrl,
          setRecordedAudioUrl,
          setRecordingTime,
          recognitionRef,
          setIsDictating,
          setInterimTranscript,
          dictationBaseRef,
          dictatedFinalRef,
          setNewComment,
        })}
        isRecording={isRecording}
        recordedAudioFile={recordedAudioFile}
        recordedAudioUrl={recordedAudioUrl}
        uploadingAudio={uploadingAudio}
        handleAddComment={handleAddComment}
        isDictating={isDictating}
        interimTranscript={interimTranscript}
        onToggleDictation={(next) => {
          if (next) {
            dictationBaseRef.current = (newComment || "").trim()
            dictatedFinalRef.current = ""
            StartSpeechRecognition({
              setIsDictating,
              dictatedFinalRef,
              setInterimTranscript,
              dictationBaseRef,
              setNewComment,
              isRecordingRef: { current: true },
              recognitionRef,
            })
          } else {
            StopSpeechRecognition({
              recognitionRef,
              setIsDictating,
              setInterimTranscript,
              dictationBaseRef,
              dictatedFinalRef,
              setNewComment,
            })
          }
        }}
      />

      <OpenMeets
        open={openMeetsModal}
        onClose={() => setOpenMeetsModal(false)}
        serviceId={meetsServiceId}
      />

      <OpenClientReviewsRequests
        open={openSolicitudRevisionesModal}
        onClose={() => setOpenSolicitudRevisionesModal(false)}
        serviceId={solicitudRevisionesServiceId}
      />

      <Modal // Modal de filtros de columnas
        activeModal={showColFiltersModal}
        onClose={() => {setShowColFiltersModal(false)}}
        title="Filtros de columnas"
        className="max-w-6xl"
        centered
      >
        <div className="flex flex-col gap-4">
          <div className="flex flex-row gap-2 items-center justify-start">
            {combos.map((combo) => (
              <button 
                key={combo.id} 
                className="flex flex-row items-center justify-start gap-2 px-3 py-2 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors duration-200"
                onClick={() => {
                  // Create new filters object with all columns initially false
                  const newColFilters = {};
                  
                  // Set all columns to false first
                  colsWithIds.forEach(col => {
                    newColFilters[col.id] = false;
                  });
                  
                  // Then set only the combo columns to true
                  combo.cols.forEach(colId => {
                    newColFilters[colId] = true;
                  });
                  
                  setColFilters(newColFilters);
                }}
              >
                <span className="text-xs font-semibold text-gray-700">{combo.name}</span>
              </button>
            ))}
          </div>
          <div className="grid grid-cols-3 gap-2 items-center justify-between">
            {colsWithIds
              .filter(col => userHasAccess(col))
              .map((col) => (
                <div key={col.id} className="flex flex-row items-center justify-start gap-2">
                  <CheckBox
                    checked={colFilters[col.id] || false}
                    onChange={(e) => {
                      setColFilters((prev) => ({
                        ...prev,
                        [col.id]: e.target.checked
                      }));
                    }}
                  />
                  <span className="text-xs font-semibold text-gray-700">{col.name}</span>
                </div>
              ))
            }
          </div>
        </div>

      </Modal>

      <DescriptionModal
        openModalDescription = {openModalDescription}
        brandName = {selectedService?.cotizacion?.cliente?.nombreComercial}
        serviceName = {selectedService?.servicio?.name}
        parsedDescription = {parsedDescription}
        setOpenModalDescription = {setOpenModalDescription}
        setSelectedService = {setSelectedService}
      />
      
      <ClientDataModal
        openModalClientData={openModalClientData}
        setOpenModalClientData={setOpenModalClientData}
        selectedClientData={selectedClientData}
        setSelectedClientData={setSelectedClientData}
        setClients={setClients}
      />

      <Modal // Modal de demos de webs
        activeModal={openModalDemo}
        onClose={() => {
          setOpenModalDemo(false)
          resetDemoForm()
          setDemoTab("list")
        }}
        title="Demos Webs"
        className="max-w-3xl"
        centered
      >
        <div className="flex flex-col gap-4">
          {/* Tabs */}
          <div className="flex flex-row gap-2 border-b border-gray-200 pb-2">
            <button
              className={`px-4 py-2 text-xs font-bold rounded-t-md transition-all duration-200 ${demoTab === "list" ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`}
              onClick={() => { setDemoTab("list"); resetDemoForm() }}
            >
              Demos existentes ({demos.length})
            </button>
            <button
              className={`px-4 py-2 text-xs font-bold rounded-t-md transition-all duration-200 ${demoTab === "create" ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`}
              onClick={() => { setDemoTab("create"); resetDemoForm() }}
            >
              <FaPlus className="inline mr-1" />
              {editingDemoIndex !== null ? "Editar demo" : "Nuevo demo"}
            </button>
          </div>

          {/* Aclaración general */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 text-xs text-blue-800">
            <p className="font-semibold mb-1">¿Cómo funciona?</p>
            <ul className="list-disc ml-4 flex flex-col gap-1">
              <li><span className="font-semibold">Sin sub-enlaces:</span> el botón redirigirá directamente al link del demo.</li>
              <li><span className="font-semibold">Con sub-enlaces:</span> el botón desplegará las opciones para elegir a cuál acceder.</li>
            </ul>
          </div>

          {/* Lista de demos existentes */}
          {demoTab === "list" && (
            <div className="flex flex-col gap-2 max-h-[500px] overflow-y-auto">
              {demos.length === 0 ? (
                <p className="text-sm text-gray-500 text-center py-8">No hay demos registrados aún.</p>
              ) : (
                demos.map((demo, index) => (
                  <div key={demo.id || index} className="flex flex-col border border-gray-200 rounded-lg px-4 py-3 bg-white hover:shadow-sm transition-all duration-200">
                    <div className="flex flex-row items-center justify-between">
                      <div className="flex flex-row items-center gap-3">
                        <FaLaptopCode className="text-blue-500" />
                        <span className="text-sm font-bold text-gray-800">{demo.itemName}</span>
                        {demo.subCategoryLinks && demo.subCategoryLinks.length > 0 ? (
                          <span className="text-[10px] bg-purple-100 text-purple-700 font-semibold px-2 py-0.5 rounded-full">Desplegable · {demo.subCategoryLinks.length} sub-enlaces</span>
                        ) : (
                          demo.itemLink ? (
                            <a href={demo.itemLink} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline text-xs flex items-center gap-1">
                              <FaExternalLinkAlt className="text-[10px]" /> Link directo
                            </a>
                          ) : (
                            <span className="text-[10px] bg-yellow-100 text-yellow-700 font-semibold px-2 py-0.5 rounded-full">Sin link</span>
                          )
                        )}
                      </div>
                      <div className="flex flex-row gap-2">
                        <button onClick={() => startEditDemo(demo, index)} className="p-2 hover:bg-gray-100 rounded-md transition-all">
                          <FaEdit className="text-green-600 text-sm" />
                        </button>
                      </div>
                    </div>
                    {/* Sub-links */}
                    {demo.subCategoryLinks && demo.subCategoryLinks.length > 0 && (
                      <div className="flex flex-wrap gap-2 mt-2 ml-8">
                        {demo.subCategoryLinks.map((sub, subIdx) => (
                          <a
                            key={sub.id || subIdx}
                            href={sub.itemLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-xs bg-gray-100 text-blue-600 hover:bg-gray-200 px-3 py-1 rounded-full flex items-center gap-1 transition-all duration-200"
                          >
                            <FaExternalLinkAlt className="text-[8px]" />
                            {sub.itemName}
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          )}

          {/* Formulario para crear/editar demo */}
          {demoTab === "create" && (
            <form
              className="flex flex-col gap-4 max-h-[500px] overflow-y-auto pr-1"
              onSubmit={(e) => {
                e.preventDefault()
                editingDemoIndex !== null ? updateDemo() : createDemo()
              }}
            >
              {/* Nombre del item */}
              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1">Nombre del demo</label>
                <input
                  type="text"
                  placeholder="Ej: Tienda virtual premium"
                  value={demoForm.itemName}
                  onChange={(e) => setDemoForm(prev => ({ ...prev, itemName: e.target.value }))}
                  className="w-full text-xs rounded-lg bg-gray-50 border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 p-2.5"
                  required
                />
              </div>

              {/* Link del item */}
              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1">Link del demo</label>
                <div className="flex">
                  <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-r-0 border-gray-300 rounded-l-md">
                    <FaLink className="text-xs" />
                  </span>
                  <input
                    type="text"
                    placeholder="https://..."
                    value={demoForm.itemLink}
                    onChange={(e) => setDemoForm(prev => ({ ...prev, itemLink: e.target.value }))}
                    className="flex-1 text-xs rounded-r-lg bg-gray-50 border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 p-2.5"
                  />
                </div>
              </div>

              {/* Sub-links */}
              <div>
                <div className="bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 mb-2">
                  <p className="text-[10px] text-gray-500">Si agregas sub-enlaces, el botón desplegará estas opciones en vez de redirigir al link de arriba.</p>
                </div>
                <div className="flex flex-row items-center justify-between mb-2">
                  <label className="block text-xs font-semibold text-gray-700">Sub-enlaces</label>
                  <button
                    type="button"
                    onClick={addSubCategoryLink}
                    className="flex items-center gap-1 text-xs text-blue-600 hover:text-blue-800 font-semibold transition-all"
                  >
                    <FaPlus className="text-[10px]" /> Agregar sub-enlace
                  </button>
                </div>
                {demoForm.subCategoryLinks.length === 0 && (
                  <p className="text-xs text-gray-400 text-center py-2">Sin sub-enlaces</p>
                )}
                <div className="flex flex-col gap-3">
                  {demoForm.subCategoryLinks.map((sub, subIdx) => (
                    <div key={subIdx} className="flex flex-row items-end gap-2 bg-gray-50 p-3 rounded-lg border border-gray-200">
                      <div className="flex-1">
                        <label className="block text-[10px] font-semibold text-gray-500 mb-1">Nombre</label>
                        <input
                          type="text"
                          placeholder="Nombre sub-enlace"
                          value={sub.itemName}
                          onChange={(e) => updateSubCategoryLink(subIdx, "itemName", e.target.value)}
                          className="w-full text-xs rounded-lg bg-white border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 p-2"
                          required
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block text-[10px] font-semibold text-gray-500 mb-1">Link</label>
                        <input
                          type="text"
                          placeholder="https://..."
                          value={sub.itemLink}
                          onChange={(e) => updateSubCategoryLink(subIdx, "itemLink", e.target.value)}
                          className="w-full text-xs rounded-lg bg-white border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 p-2"
                          required
                        />
                      </div>
                      <button
                        type="button"
                        onClick={() => removeSubCategoryLink(subIdx)}
                        className="p-2 hover:bg-red-50 rounded-md transition-all"
                      >
                        <FaTrash className="text-red-500 text-xs" />
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              {/* Botón de enviar */}
              <Button
                variant="contained"
                sx={{
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  paddingBlock: "8px",
                  backgroundColor: "#3b82f6",
                  textTransform: "none",
                  borderRadius: "8px",
                  width: "100%",
                  fontSize: "small",
                  '&:hover': { backgroundColor: "#2563eb" }
                }}
                type="submit"
              >
                {editingDemoIndex !== null ? "Actualizar demo" : "Crear demo"}
              </Button>
            </form>
          )}
        </div>
      </Modal>

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <div className="flex items-center gap-4 py-4">
            <FaWordpress className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Proyectos Webs</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            <MainSaveButton
              text="Registrar demo"
              icon={<AddIcon />}
              onClick={() => setOpenModalDemo(true)}
            />

            {(isAdmin || isOperative) && (
              <Selector
                title="Vista"
                value={view}
                setter={setView}
                width="w-[8rem]"
                options={[{label: "Vertical", value: "Vertical"}, {label: "Horizontal", value: "Horizontal"}]}
                disabled={loadingStatus}
              />
            )}

            <Selector
              title="Límite"
              value={limit}
              setter={setLimit}
              options={Limits10_50}
              width="w-[5rem]"
              disabled={loadingStatus}
            />

            <SearchBar
              value={brandName}
              setter={setBrandName}
              pageSetter={setPage}
              getter={getClients}
              placeholder="Buscar marca..."
              text="Buscar"
              disabled={loadingStatus}
            />

          </div>

        </div>
      </div>

      {/* Filtros de fechas */}       
      <div className="flex flex-row w-full bg-gray-100 mt-0.5 gap-8">
        <div className="flex flex-row w-full items-center gap-4 justify-center overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">

          <DateInput
            title="Fecha inicio"
            value={startDate}
            setter={setStartDate}
            disabled={loadingStatus}
          />

          <DateInput
            title="Fecha fin"
            value={endDate}
            setter={setEndDate}
            disabled={loadingStatus}
          />

          <Selector
            title="Responsable"
            value={responsible}
            setter={setResponsible}
            disabled={loadingStatus}
            width="w-[8rem]"
            options={[{value: "", label: "Todos"}, ...areaWorkers.map((worker) => ({label: worker.name, value: worker.id}))]}
          />
          
          <Selector
            title="Enfoque web"
            value={enfoqueWeb}
            setter={setEnfoqueWeb}
            disabled={loadingStatus}
            width="w-[8rem]"
            options={EnfoqueWebOptions}
          />

          <Selector
            title="Recompra potencial"
            value={recompraPotencial}
            setter={setRecompraPotencial}
            disabled={loadingStatus}
            width="w-[8rem]"
            options={[{label: "Todos", value: ""}, ...OpcionesRecompraPotencial]}
          />
          
          <CheckBox
            checked={agencyWeb}
            onChange={(e) => setAgencyWeb(e.target.checked)}
            disabled={loadingStatus}
            text="Activos Agencia"
          />

          {/* Columnas activas */}
          {view === "Horizontal" && (
            <FilterButton action={() => setShowColFiltersModal(true)} content="Filtros de columnas" />
          )}
        </div>
      </div>

      {/* Web status */}
      <div className="flex flex-row bg-gray-100 mt-0.5 mb-0.5 pt-1 pb-2 px-4">
        <div className="flex flex-row w-full items-center pt-1 justify-center gap-4 overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <Multiselector 
            title="Servicios"
            value={serviceFilters}
            handlerChange={(vals) => setServiceFilters(vals)}
            options={webServices}
            disabled={loadingStatus}
            formControlHeight={32}
            formControlWidth="10vw"
            menuItemWitdh={270}
            itemHeight={48}
            menuItemHeight="30px"
            itemWidth="40vw"
          />
          <Multiselector 
            title="Estado"
            value={statusFilters}
            handlerChange={(vals) => setStatusFilters(vals)}
            options={webServiceStatus}
            disabled={loadingStatus}
            formControlHeight={32}
            formControlWidth="10vw"
            menuItemWitdh={200}
            itemHeight={48}
            menuItemHeight="30px"
            itemWidth="40vw"
          />
          {/* <Multiselector 
            title="Prioridad"
            value={priorityFilters}
            handlerChange={(vals) => setPriorityFilters(vals)}
            options={prioridadesWebs}
            disabled={loadingStatus}
            formControlHeight={32}
            formControlWidth="10vw"
            menuItemWitdh={450}
            itemHeight={48}
            menuItemHeight="30px"
            itemWidth="40vw"
          /> */}
          <Selector
            title="VIP"
            value={vipClient}
            setter={setVipClient}
            disabled={loadingStatus}
            width="w-[8rem]"
            options={[{value: "", label: "Todos"}, ...vipClientValues]}
          />
          <PaginationItem 
            actualDocs={clients.length}
            totalDocs={totalDocs}
            entity={"clientes"}
            totalPages={totalPages}
            actualPage={page}
            handlePageChange={handlePageChange}
            variant="horizontal"
          />
        </div>
      </div>
      
      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
          <LoadingScreen />
          ) : (
            clients.length === 0 ? (
              <NoDataScreen />
            ) : (
              view === "Vertical" ? (
                <table className="w-full table-fixed">
                  <thead className="bg-white sticky top-0 z-50">
                    <tr className="w-full text-gray-700 text-center text-[10px] font-semibold">
  
                      <td className="w-[15%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        <div>
                          Cliente
                        </div>
                      </td>
                      {webServices
                        .filter((service) => serviceFilters.length === 0 || serviceFilters.includes(service.id))
                        .map((service) => (
                          <td
                            key={service.id}
                            className="px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red"
                          >
                            <div>{service.name}</div>
                          </td>
                        ))
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {clients.map((client, rowIndex) => (
                      <tr
                        key={client.id}
                        className={`text-xs py-2 w-full hover:bg-gray-100 transition-all duration-300`}
                      >
                        <td 
                          scope="row" 
                          className="max-w-[20px] px-4 py-2 max-w-xs font-bold border border-gray-300 text-center hover:cursor-pointer hover:underline transition-all duration-100"
                        >
                          <a 
                            href={`/home/seguimiento/${client.id}`}
                            target="_blank" 
                            rel="noopener noreferrer"
                          >
                            {client.nombreComercial}
                          </a>
                        </td>
  
                        {webServices
                          .filter((service) => serviceFilters.length === 0 || serviceFilters.includes(service.id))
                          .map((service) => (
                            <WebsBoxItemContainer 
                              key={service.id} 
                              service={service} 
                              client={client}
                              user={user}
                              permissions={permissions}
                              allServiciosList={webServices}
                              workers={workers}
                            />
                          ))
                        }
  
                      </tr>
                    ))}
                  </tbody>
                </table>  
              ) : (
                <table className="w-full text-xs">
                  <thead className="sticky top-0 bg-gray-200 z-50">
                    <tr className="text-gray-700 text-center text-[10px] font-bold z-50">
                      {colsWithIds
                        .filter(col => shouldShowColumn(col))
                        .map(col => (
                          <th key={col.id} className={`${(col.first || col.second || col.third) ? "sticky" : ""} z-20 px-2 py-3 text-center bg-[#FE6400] text-white z-50`} style={(col.first || col.second || col.third) ? { left: stickyOffsets[col.first ? 'first' : col.second ? 'second' : 'third'] } : undefined}>
                            <div className="flex flex-col items-center justify-center gap-1">
                              {col.name}
                              {col.chipContent ? <span className="text-black">{ChipInfo(col.chipContent)}</span> : null}
                              {col.description ? <TooltipInfoQuestion content={col.description} /> : null}
                            </div>
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                  {clients.map((c) => c.services.map((s, i) => {
                    return (
                      <WebRowItemContainer
                        key={i}
                        sticky={[1, 2]}
                        serviceData={s}
                        c={c}
                        activeCols={colsWithIds}
                        shouldShowColumn={shouldShowColumn}
                        stickyOffsets={stickyOffsets}
                        setClients={setClients}
                        user={user}
                        permissions={permissions}
                        setOpenModalDescription={setOpenModalDescription}
                        setSelectedService={(srv)=>{ setSelectedService(srv); }}
                        setOpenModalComments={(open, opts={})=>{ setCommentType(opts?.type || "default"); setOpenModalComments(open); }}
                        webServices={webServices}
                        setOpenModalClientData={setOpenModalClientData}
                        setSelectedClientData={setSelectedClientData}
                        areaWorkers={areaWorkers}
                        onOpenMeets={(serviceId) => {
                          setMeetsServiceId(serviceId);
                          setOpenMeetsModal(true);
                        }}
                        onOpenSolicitudRevisiones={(serviceId) => {
                          setSolicitudRevisionesServiceId(serviceId);
                          setOpenSolicitudRevisionesModal(true);
                        }}
                      />
                    )
                  }))}
                  </tbody>
                </table> 
              )
            )
          )
        }
      </div>

    </div>   
  )
}

export default ProyectosWebs